import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    empid: "",
    innerHeight: window.innerHeight,
    screenHeight: document.body.clientHeight,
    editableTabs: [{
      menuname: '首页',
      menuurl: '/homePage',
      menukey: 'homePage'
    }],
    aliveList: ['homePage'],
    contextMenu: {},
    //activeTab: '/homePage',
    baseInfoObj: {},
    routers: [],
    disabled: true,
    editFlag: true,
    showEditSalaryTable: true,
    showOnJobRosterTable: true,
    showDepartureRosterTable: true,
    showDepartureHistoryTable: true,
  },
  mutations: {
    changeScreenHeight(state, d) {
      state.screenHeight = d;
    },
    changeEditableTabs(state, d) {
      state.editableTabs = d;
    },
    changeAliveList(state, d) {
      state.aliveList = d;
    },
    setInnerHeight(state, d) {
      state.innerHeight = d;
    },
    setEmpid(state, d) {
      state.empid = d
    },
    setBaseInfoObj(state, d) {
      for (let m in d) {
        state.baseInfoObj[m] = d[m]
      }
    },
    setFlag(state, d) {
      state.disabled = d;
    },
    setEditFlag(state, d) {
      state.editFlag = d;
    },
  },
  actions: {
    changeEditableTabs(context, d) {
      context.commit("changeEditableTabs", d)
    },
    changeAliveList(context, d) {
      context.commit("changeAliveList", d)
    },
    setBaseInfoObj(context, d) {
      context.commit("setBaseInfoObj", d)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js